export default __webpack_public_path__ + "static/media/Icon=Departments.14a1635c.svg";